import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useRef } from 'react';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
export var getActiveTunnelsQuery = function getActiveTunnelsQuery() {
  var query = "\n  query forge_ui_getActiveTunnels($appId: ID!, $environmentId: ID!) {\n    appActiveTunnels(appId: $appId, environmentId: $environmentId) {\n      customUI {\n        resourceKey\n        tunnelUrl\n      }\n    }\n  }\n  ";
  return gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t", "\n\t"])), query);
};
export var createAppTunnelsQueryOptions = function createAppTunnelsQueryOptions(client, appId, environmentId, queryOptions) {
  return _objectSpread(_objectSpread({
    variables: {
      appId: appId,
      environmentId: environmentId
    }
  }, queryOptions), {}, {
    query: getActiveTunnelsQuery(),
    client: client,
    /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */
    errorPolicy: 'all'
  });
};
export var getCustomUITunnelsFromGQLResult = function getCustomUITunnelsFromGQLResult(_ref) {
  var loading = _ref.loading,
    data = _ref.data;
  if (!loading) {
    var _data$appActiveTunnel;
    return data === null || data === void 0 || (_data$appActiveTunnel = data.appActiveTunnels) === null || _data$appActiveTunnel === void 0 ? void 0 : _data$appActiveTunnel.customUI;
  }
  return undefined;
};
export var useCustomUITunnelsList = function useCustomUITunnelsList(options) {
  var appId = options.appId,
    environmentType = options.environmentType,
    environmentId = options.environmentId,
    client = options.client,
    queryOptions = options.queryOptions;
  var shouldQuery = useRef(true);
  if (environmentType !== 'DEVELOPMENT') {
    shouldQuery.current = false;
  }
  var requestOptions = createAppTunnelsQueryOptions(client, appId, environmentId, queryOptions);
  var _useQuery = useQuery(requestOptions.query || getActiveTunnelsQuery(), _objectSpread(_objectSpread({}, requestOptions), {}, {
      skip: !shouldQuery.current
    })),
    error = _useQuery.error,
    loading = _useQuery.loading,
    data = _useQuery.data;
  var tunnels = getCustomUITunnelsFromGQLResult({
    loading: loading,
    data: data
  });
  return {
    error: error,
    tunnels: tunnels || [],
    loading: loading
  };
};